import { Component, OnInit } from '@angular/core';
import { LoaderService, RedirectStorageService } from 'ats-ui-lib';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../root/auth/auth.service';

@Component({
  selector: 'ats-auth-social-login-callback',
  templateUrl: './auth-social-login-callback.component.html',
  styleUrls: ['./auth-social-login-callback.component.css'],
  standalone: false,
})
export class AuthSocialLoginCallbackComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private loaderService: LoaderService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private window: Window,
    private redirectStorage: RedirectStorageService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.loaderService.show();
    try {
      await this.authService.init();
      const loggedUser = this.authService.snapshot;
      if (loggedUser != null) {
        await this.redirection();
      } else {
        await this.authService.fluigLogin();
      }
    } finally {
      this.loaderService.hide();
    }
  }

  async redirection(): Promise<void> {
    const previousRouteId: string | undefined = this.activatedRoute.snapshot.params.previousRoute;
    const previousRoute = previousRouteId
      ? this.redirectStorage.getRedirectRoute(previousRouteId)
      : previousRouteId;
    if (previousRoute == null) {
      await this.router.navigate(['main', 'home']);
    } else {
      this.window.location.href = previousRoute;
    }
  }
}
